import type { ProductListItem } from "../types";

export const mapToProductList = (productList: ProductListItem[]) => {
  return productList.map((product) => ({
    ...product
  }));
};
